import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=0279167e"
import script from "./reportDetails.vue?vue&type=script&lang=js"
export * from "./reportDetails.vue?vue&type=script&lang=js"
import style0 from "./reportDetails.vue?vue&type=style&index=0&id=0279167e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports